






























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { apiQueryBuilder, objectIsEmpty } from '~/utils/common.js';

import LocalisationDestinations from '~/components/lists/LocalisationDestinations.vue';
import LocalisationRoutes from '~/components/lists/LocalisationRoutes.vue';
import LocalisationEvents from '~/components/lists/LocalisationEvents.vue';
import { footSports } from "~/utils/runConstants";

@Component({
  layout: 'localisation-map',
  computed: {
    ...mapState('explorer', [
      'localisationTab',
      'displayLocalisationMap',
      'destinationsList',
      'destinationsMap',
      'routesList',
      'routesMap',
      'eventsList',
      'eventsMap',
      'userCoords',
      'destinationDestinationFilters',
      'destinationRoutesFilters',
      'destinationEventsFilters',
      'hasChangedLanguage',
      'explorerBounds',
      'sports',
    ]),
    ...mapState('lang', [
      'locale',
    ]),
  },
  middleware: ['noauth', 'explorer/localisationMap'],
  components: {
    LocalisationDestinations,
    ExplorerMap: () => {
      if (process.client) {
        return import('~/components/maps/ExplorerMap.vue');
      }
    },
    LocalisationRoutes,
    LocalisationEvents,
  },
  head () {
    const self: any = this;
    const locale: string = self.$store.state.lang.locale;

    return {
      title: `${self.$t('globalSearchCard.exploreLabel')} - On Piste`,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${self.$t('globalSearchCard.exploreLabel')} - On Piste`,
        },
        {
          hid: 'description',
          name: 'description',
          content: `${self.$t('explorer.index.description')}`,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: `${self.$t('explorer.index.description')}`,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: 'https://www.onpiste.com/img/placeholders/OnPiste_Logo_FB.jpg',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://www.onpiste.com/${locale === 'fr' ? '' : `${locale}/`}explorer`,
        },
      ],
    };
  },
  // async fetch () {
  //   if (process.server) {
  //     await this.callAllResults({
  // todo
  // [36.23901207750932, -7.635498046875001],
  // [58.53619011845253, 24.005126953125004],
  //       _southWest: { lat: -90, lng: -180 },
  //       _northEast: { lat: 90, lng: 180 },
  //     });
  //   }
  // },
})
export default class Explorer extends Vue {
  localisationTab: string;
  displayLocalisationMap: boolean;
  locale: string;
  destinationsList: Types.DestinationList;
  destinationsMap: Types.DestinationMap;
  routesList: Types.RouteList;
  routesMap: any;
  sports: Types.SportItem[];
  eventsList: Types.EventList;
  eventsMap: Types.EventMap;
  userCoords: Types.userCoords;
  destinationRoutesFilters: {[key: string]: any};
  destinationDestinationFilters: {[key: string]: any};
  destinationEventsFilters: {[key: string]: any};
  hasChangedLanguage: boolean;
  explorerBounds: {[key: string]: number};

  hoveredDestination: Types.DestinationItem | null = null;
  hoveredEvent: Types.Event | null = null;
  hoveredRoute: Types.Route | null = null;

  distanceRange: any = [];
  elevationRange: any = [];

  forceReset: boolean = false;

  mapBounds: any = {};
  destinationRespects: boolean = false;
  destinationLandscapes: string[] = [];
  destinationLabels: number[] = [];
  destinationSports: string[] = [];

  routeDifficulties: number[] = [];
  routeOpened: boolean = false;
  routeTypes: string[] = [];
  routeLabels: number[] = [];
  routeSports: string[] = [];
  routeElevationMin: number | null = null;
  routeElevationMax: number | null = null;
  routeDistanceMin: number | null = null;
  routeDistanceMax: number | null = null;

  eventSports : string[] = [];
  eventTypes: any[] = [];
  eventLabels: number[] = [];
  eventSince: string = '';
  eventUntil: string = '';

  destinationOffset: number = 0;
  routeOffset: number = 0;
  eventOffset: number = 0;

  cityFiltered: string = '';
  defaultEuropeBounds: Array<number[]> = [
    [36.13901207750932, -7.635498046875001],
    [58.53619011845253, 24.005126953125004],
  ];

  activePayload: {[key: string]: any} = {};
  mobileHidder: boolean = false;

  /*
    Will get every cities in this.routesMap elements to put them in the
    RouteCitiesDropdown.
  */
  get routeCities () {
    const items = this.routesMap;
    const cities = [...new Set(items?.map((r: any) => r.properties?.city))].sort();
    return cities.filter(c => c !== null);
  }

  /*
    This computed will remove potential duplicates in array. It can happen when
    user clicks a marker on map that can be append to this.routesList.
    This filter will ensure no duplicates are added to store values.
  */
  get routesToShow () {
    return this.routesList?.items?.filter((v: Types.Route, i: number, a: any) => a.findIndex((t: Types.Route) => (t.id === v.id)) === i);
  }

  /* ⬆️ */
  get destinationsToShow () {
    return this.destinationsList?.items?.filter((v: Types.Route, i: number, a: any) => a.findIndex((t: Types.Route) => (t.id === v.id)) === i) || [];
  }

  /* ⬆️ */
  get eventsToShow () {
    return this.eventsList?.items?.filter((v: Types.Event, i: number, a: any) => a.findIndex((t: Types.Event) => (t.id === v.id)) === i) || [];
  }

  get sportToShow () {
    const sportsToShow = [...this.sports.filter(sport => sport.has_route).map(sport => sport.id)];

    // if we want to add a dynamic sports-based on current map's routes
    // const arraySports: any[] = [];
    // this.routesMap.forEach((route: { properties: { sport_id: any; }; }) => {
    //   !arraySports.includes(route.properties.sport_id) && arraySports.push(route.properties.sport_id);
    // });
    // const sportsToShow = arraySports;

    const sportsToSend: any[] = [];
    const allSports: Types.SportItem[] = [];
    // for each id in sportsToShow, find the corresponding sport
    sportsToShow.forEach((id : any) => {
      const indexOfSport = this.sports.findIndex(obj => obj.id === id);
      // if sport have a parent_id
      if (this.sports[indexOfSport].parent_id) {
        // if parent_id wasn't already in array, push it
        const parentIndex = this.sports.findIndex(obj => obj.id === this.sports[indexOfSport].parent_id);
        const sportParent = this.sports[parentIndex];
        if (allSports.every(sport => sport.id !== this.sports[indexOfSport].parent_id)) {
          allSports.push({
            'id': sportParent.id,
            'title': sportParent.title,
            'icon_name': sportParent.icon_name,
            'children':[],
            'universe': sportParent.universe,
          });
        }
        const parentIndexOfAllSports = allSports.findIndex(obj => obj.id === sportParent.id);
        const sportCopy = { ...this.sports[indexOfSport] };
        allSports[parentIndexOfAllSports].children?.push(sportCopy);
      } else {
        const sportCopy = { ...this.sports[indexOfSport], children:[] };
        allSports.every(sport => sport.id !== this.sports[indexOfSport].id) && allSports.push(sportCopy);
      }
    });
    allSports.forEach((sport) => {
      if (sportsToSend.every(element => element.title !== sport.universe)) {
        sportsToSend.push({ 'title': sport.universe, 'sports': [sport] });
      } else {
        const universeIndex = sportsToSend.findIndex(obj => obj.title === sport.universe);
        sportsToSend[universeIndex].sports?.push(sport);
      }
    });
    const customSortUniverse = (a: { title: string; }, b: { title: string; }) => {
      const order = ['FOOT', 'BIKE', 'WINTER'];
      return order.indexOf(a.title) - order.indexOf(b.title);
    };
    const sortWithTrailFirst = (array: any[]) => {
      if (array.some(sport => sport.title === this.$t(footSports[0].name))) {
        array.sort((a, b) => {
          if (a.title === this.$t(footSports[0].name)) return -1;
          if (b.title === this.$t(footSports[0].name)) return 1;
          return 0;
        });
      }
    };
    sportsToSend.sort(customSortUniverse);
    if (sportsToSend.length > 0) {
      sortWithTrailFirst(sportsToSend[0].sports);
    }
    // sort array with custom sort
    return sportsToSend;
  }

  /*
    Depending of this.cityFiltered string, we will filter this.routesMap to
    display them on ExplorerMap. If no city is filtered, we display all
    this.routesMap
  */
  get routesMapToShow () {
    if (this.cityFiltered) {
      return this.routesMap?.filter((r: any) => r.properties.city === this.cityFiltered);
    }
    return this.routesMap || [];
  }

  /* Returns sport ids that are in route queries if defined */
  get sportQueries () {
    return this.$route.query?.sport
      ? Array.isArray(this.$route.query.sport) ? this.$route.query.sport.map(s => Number(s)) : [this.$route.query.sport]
      : null;
  }

  /*
    This computed will return bounds to init ExplorerMap on some specific:
    - If user wants aroundMe, ExplorerMap will be init around user's coords
    - If actual route contains queries with a coord (lat/lng) or bounds (latMin/
    latMax/lngMin/lngMax), ExplorerMap will be fit on these
    - If page contains custom bounds (explained in computed, this.explorerBounds),
    will fit on them
  */
  get searchBounds () {
    const aroundMeQuery: any = this.$route.query?.aroundMe;
    if (aroundMeQuery?.trim() === 'true' && this.userCoords) {
      this.$store.commit('explorer/SET_EXPLORER_FORCE_CALLS', true);

      return [this.userCoords?.lat, this.userCoords?.lng] || this.defaultEuropeBounds;
    }

    if (
      this.$route.query?.long &&
      this.$route.query?.lat
    ) {
      this.activePayload = {
        long: this.$route.query.long,
        lat: this.$route.query.lat,
      };

      return [
        [Number(this.$route.query?.lat), Number(this.$route.query?.long)],
        [Number(this.$route.query?.lat), Number(this.$route.query?.long)],
      ];
    }
    if (
      this.$route.query?.longmin &&
      this.$route.query?.latmin &&
      this.$route.query?.longmax &&
      this.$route.query?.latmax
    ) {
      this.activePayload = {
        longmin: this.$route.query.longmin,
        latmin: this.$route.query.latmin,
        longmax: this.$route.query.longmax,
        latmax: this.$route.query.latmax,
      };

      return [
        [Number(this.$route.query?.latmin), Number(this.$route.query?.longmin)],
        [Number(this.$route.query?.latmax), Number(this.$route.query?.longmax)],
      ];
    }

    // This edge-case can happen if user changes language. When this case occurs,
    // some datas can be deleted and bounds incorrect after the update.
    // this.explorerBounds will ensure map isn't reload on -90/90 : -180/180 when
    // user changes language.
    if (!objectIsEmpty(this.explorerBounds)) {
      return [
        [Number(this.explorerBounds.lat_min), Number(this.explorerBounds.long_min)],
        [Number(this.explorerBounds.lat_max), Number(this.explorerBounds.long_max)],
      ];
    }
  }

  /*
    As explained in this.searchBounds, nuxt-18n pushes to current location but
    with another locale if user changes language. As we don't want our view to
    change its datas except text constants, this bellowed method will ensure
    page datas are saved and usable later in other methods.
  */
  @Watch('locale')
  handleResetOnLocale () {
    if (
      Number(this.mapBounds.lat_max) === 90 &&
      Number(this.mapBounds.lat_min) === -90 &&
      Number(this.mapBounds.long_max) === 180 &&
      Number(this.mapBounds.long_min) === -180
    ) {
      this.$store.commit('explorer/SET_EXPLORER_BOUNDS', {
        lat_min: this.defaultEuropeBounds[0][0],
        lat_max: this.defaultEuropeBounds[1][0],
        long_min: this.defaultEuropeBounds[0][1],
        long_max: this.defaultEuropeBounds[1][1],
      });
    } else {
      this.$store.commit('explorer/SET_EXPLORER_BOUNDS', this.mapBounds);
    }

    this.$store.commit('explorer/SET_HAS_CHANGED_LANGUAGE', true);
  }

  /*
    When changing tab in view, we want the filters that were applied previously
    to be applied one more time. As the filters are stored in one different state
    for each tab, this method will update URL to append queries with associated
    values.
  */
  @Watch('localisationTab')
  adaptQueryOnTab (val: string) {
    let payload: any = {};

    // These coords represent the entire world, and except if query ?seeall=true
    // is in URL, we don't want the view to be so large. So we remove these
    // attributes.
    if (this.activePayload.latmax === 90) delete this.activePayload.latmax;
    if (this.activePayload.latmin === -90) delete this.activePayload.latmin;
    if (this.activePayload.longmax === 180) delete this.activePayload.longmax;
    if (this.activePayload.longmin === -180) delete this.activePayload.longmin;
    switch (val) {
      case 'destinations': {
        payload = Object.assign(
          {},
          this.activePayload,
          this.destinationDestinationFilters,
          { tab: 'destinations' },
        );
        break;
      }
      case 'routes': {
        payload = Object.assign(
          {},
          this.activePayload,
          this.destinationRoutesFilters,
          { tab: 'routes' },
        );
        break;
      }
      case 'events': {
        payload = Object.assign(
          {},
          this.activePayload,
          this.destinationEventsFilters,
          { tab: 'events' },
        );
        break;
      }
    }

    this.appendQueries(payload);
  }

  /*
    This watcher is applied everytime user uses global search on a new
    location. When such action occurs, every filter must be reset.
  */
  @Watch('$route')
  handleRouteChange () {
    this.$nuxt.$emit('reset-queries');
    this.$store.commit('explorer/SET_DESTINATION_MAP_ROUTES_FILTERS', null);
    this.$store.commit('explorer/SET_DESTINATION_MAP_EVENTS_FILTERS', null);
    this.$store.commit('explorer/SET_DESTINATION_MAP_DESTINATIONS_FILTERS', null);

    this.destinationRespects = false;
    this.destinationLandscapes = [];

    this.routeDifficulties = [];
    this.routeOpened = false;
    this.routeTypes = [];
    this.routeLabels = [];
    this.routeSports = [];
    this.routeElevationMin = null;
    this.routeElevationMax = null;
    this.routeDistanceMin = null;
    this.routeDistanceMax = null;

    this.eventTypes = [];
    this.eventSince = '';
    this.eventUntil = '';

    if (this.$route.query && this.$route.query.aroundMe) {
      const query: any = this.$route.query.aroundMe;
      if (query.trim() === 'true') {
        // This emit will force update ExplorerMap to
        // fit bounds correctly on user cords
        this.$root.$emit('trigger-bounds-update', [this.userCoords?.lat, this.userCoords?.lng]);
      }
    }

    // We can complete URL queries with the new search applied.
    this.prefillQueries();
  }

  beforeMount () {
    if (process.client) {
      // We don't want to show the map by default on small devices
      if (window.innerWidth <= 768) {
        this.$store.commit('explorer/SET_LOCALISATION_MAP_DISPLAY', true);
        this.mobileHidder = true;
        setTimeout(() => {
          this.$store.commit('explorer/SET_LOCALISATION_MAP_DISPLAY', false);
          this.mobileHidder = false;
        }, 200);
      }
    }

    // As explained upper in code, we don't want our filters to be updated when
    // page re-renders after changng language
    if (!this.hasChangedLanguage) this.prefillQueries();
    else {
      // Else, we populate filters, fit bounds of ExplorerMap correctly and
      // handle every other edge-cases related to aroundMe position
      if (
        Number(this.explorerBounds.lat_max) !== 90 &&
        Number(this.explorerBounds.lat_min) !== -90 &&
        Number(this.explorerBounds.long_max) !== 180 &&
        Number(this.explorerBounds.long_min) !== -180
      ) {
        this.mapBounds = {
          lat_min: Number(this.explorerBounds.lat_min),
          lat_max: Number(this.explorerBounds.lat_max),
          long_min: Number(this.explorerBounds.long_min),
          long_max: Number(this.explorerBounds.long_max),
        };
      }

      const queries: any = this.$route.query;

      if (
        !objectIsEmpty(this.explorerBounds) &&
        !queries.locname &&
        !queries.aroundMe
      ) {
        this.$root.$emit('selected-area', {
          _southWest: { lat: this.explorerBounds.lat_min, lng: this.explorerBounds.long_min },
          _northEast: { lat: this.explorerBounds.lat_max, lng: this.explorerBounds.long_max },
        });
      }
      this.populateDestinationFilters(this.destinationDestinationFilters);
      this.populateRouteFilters(this.destinationRoutesFilters);
      this.populateEventFilters(this.destinationEventsFilters);

      const payload = Object.assign(
        {},
        this.$route.query,
        {
          latmax: this.mapBounds.lat_max,
          latmin: this.mapBounds.lat_min,
          longmin: this.mapBounds.long_min,
          longmax: this.mapBounds.long_max,
        },
      );
      this.appendQueries(payload);
    }
  }

  mounted () {
    // Logic is applied when user is in globalSearch and actually on explorer page
    this.$nuxt.$on('searches-around-me', () => {
      this.handleRouteChange();
    });

    this.$root.$on('reset-routes-ranges', () => {
      this.elevationRange = [];
      this.distanceRange = [];
    });
    this.$root.$emit('remove-selected-area-button');

    if (!this.$store.state.explorer.labels.length) {
      this.$store.dispatch('explorer/getLabels', { lang: this.$store.state.lang.locale });
    }
  }

  beforeDestroy () {
    // Will reset every filters applied when leaving page.
    // We don't want this behavior to occur when user changes language (as
    // page is destroying then remounting when doing that)
    if (!this.hasChangedLanguage) {
      this.$store.commit('explorer/SET_ROUTES_MAP', []);
      this.$store.commit('explorer/SET_LOCALISATION_TAB', 'destinations');
      this.$store.commit('explorer/SET_DESTINATION_MAP_ROUTES_FILTERS', {});
      this.$store.commit('explorer/SET_DESTINATION_MAP_EVENTS_FILTERS', {});
      this.$store.commit('explorer/SET_DESTINATION_MAP_DESTINATIONS_FILTERS', {});
    }
  }

  /*
    Calling all results is a method called when entering the page.
    This method will fetch routes/events/destinations cards on the left
    side of the view (not the map elements). If it contains a
    val.reset_append argument, it means that when fetching datas, the
    offset sent will be at 0, so the datas fetched are reset from scratch.
    It prevents user to fetch too ahead datas than where he actually is when
    scrolling through cards.
  */
  async callAllResults (val: any) {
    if (objectIsEmpty(this.explorerBounds)) {
      // Sometimes if user selects area where bounds are out of the world, coords
      // aren't handled by API as min/max coords are -90/90 -180/180
      // If one of these coords gets out of limit, by default we bring them back
      // to -90/90 -180/180
      const bounds = {
        lat_min: val.content._southWest.lat <= -89 ? -90 : val.content._southWest.lat,
        lat_max: val.content._northEast.lat >= 89 ? 90 : val.content._northEast.lat,
        long_min: (val.content._southWest.lng <= -180 || val.content._southWest.lng >= 180) ? -180 : val.content._southWest.lng,
        long_max: (val.content._northEast.lng >= 180 || val.content._northEast.lng <= -180) ? 180 : val.content._northEast.lng,
      };

      this.mapBounds = bounds;
    }

    await this.searchDestinations({ reset_append: val.reset_append });
    await this.searchRoutes({ reset_append: val.reset_append });
    await this.searchEvents({ reset_append: val.reset_append });

    this.activePayload = {
      longmin: this.mapBounds.long_min,
      latmin: this.mapBounds.lat_min,
      longmax: this.mapBounds.long_max,
      latmax: this.mapBounds.lat_max,
    };
  }

  /* This method updates active history (URL) to handle filters applied by user */
  appendQueries (payload: any) {
    if (process.client) {
      history.replaceState(
        {},
        '',
      `${this.locale !== 'fr' ? `/${this.locale}` : ''}/explorer${apiQueryBuilder(payload)}`,
      );
    }
  }

  /*
    This method is called everytime a filter is applied in dropdowns.
    The method will get azctive qsueries in route, and add the new filters given
    by active tab list
  */
  prepareQueries (payload: any) {
    this.$store.commit('explorer/SET_EXPLORER_FORCE_CALLS', true);

    if (this.activePayload.latmax === 90) delete this.activePayload.latmax;
    if (this.activePayload.latmin === -90) delete this.activePayload.latmin;
    if (this.activePayload.longmax === 180) delete this.activePayload.longmax;
    if (this.activePayload.longmin === -180) delete this.activePayload.longmin;

    if (this.$route.query?.loc) {
      payload.loc = this.$route.query?.loc;
    } else if (this.$route.query?.locname) {
      payload.locname = this.$route.query?.locname;
    }
    const payloadToSend = payload;
    payloadToSend.tab = this.localisationTab;
    if (!objectIsEmpty(this.activePayload)) {
      this.appendQueries(Object.assign({}, payloadToSend, this.activePayload));
    } else {
      this.appendQueries(payloadToSend);
    }
  }

  /*
    When user uses "Select in this area" in ExplorerMap, it will Keep active
    queries in URL, save the ones that are in dropdowns so we can
    create an all new URL
  */
  updateRoute () {
    this.routeOffset = 0;

    const payload: {[key: string]: any} = {
      longmin: this.mapBounds.long_min,
      latmin: this.mapBounds.lat_min,
      longmax: this.mapBounds.long_max,
      latmax: this.mapBounds.lat_max,
    };

    /* eslint array-callback-return: 0 */
    const sportQueries = this.$route.query?.sport || '';
    if (sportQueries) {
      if (typeof sportQueries === 'string') {
        payload.sport = sportQueries;
      } else {
        for (let i = 0; i < sportQueries.length; i++) {
          payload.sport = sportQueries;
        }
      }
    }

    if (this.localisationTab === 'routes') {
      for (const routeFilter in this.destinationRoutesFilters) {
        if (this.destinationRoutesFilters[routeFilter]) {
          payload[routeFilter] = this.destinationRoutesFilters[routeFilter];
        }
      }
    }

    if (this.localisationTab === 'destinations') {
      for (const destinationFilter in this.destinationDestinationFilters) {
        if (this.destinationDestinationFilters[destinationFilter]) {
          payload[destinationFilter] = this.destinationDestinationFilters[destinationFilter];
        }
      }
    }

    if (this.localisationTab === 'events') {
      for (const eventFilter in this.destinationEventsFilters) {
        if (this.destinationEventsFilters[eventFilter]) {
          payload[eventFilter] = this.destinationEventsFilters[eventFilter];
        }
      }
    }

    payload.tab = this.localisationTab;
    if (this.$route.query?.loc) {
      payload.loc = this.$route.query?.loc;
    } else if (this.$route.query?.locname) {
      payload.locname = this.$route.query?.locname;
    }

    this.activePayload = payload;

    this.appendQueries(payload);
    this.$root.$emit('remove-selected-area-button');
  }

  /*
    We prefill queries when page is mounted (hasn't change language), or when
    user attempts a new search in page. The objective of this
    method is to prefill page datas if the route contains queries that allow it.
    Every logic here is based on route URL when user arrives on the page/uses
    globalSearch on the page.
  */
  prefillQueries () {
    if (this.$route.query?.loc) {
      this.activePayload.loc = this.$route.query?.loc;
    } else if (this.$route.query?.locname) {
      this.activePayload.locname = this.$route.query?.locname;
    }

    const destinationLandscapes: string[] = [];
    let destinationRespect: boolean = false;
    const routeTypesInStore: string[] = [];
    const routeDifficultiesInStore: number[] = [];
    let routeElevationMinInStore: number = 0;
    let routeElevationMaxInStore: number = 0;
    let routeDistancesMinInStore: number = 0;
    let routeDistancesMaxInStore: number = 0;
    let routeIsOpened: boolean = false;
    let routeCity: any = '';

    if (this.$route.query['landscape[]']) {
      const query: any = this.$route.query['landscape[]'];
      const typeOfQuery = typeof query === 'string';
      if (typeOfQuery) destinationLandscapes.push(query);
      else {
        query.map((t: string) => {
          destinationLandscapes.push(t);
        });
      }
      this.destinationLandscapes = destinationLandscapes;
    }

    if (this.$route.query?.respect) {
      destinationRespect = true;
      this.destinationRespects = true;
    }

    if (this.$route.query['types[]']) {
      const query: any = this.$route.query['types[]'];
      const typeOfQuery = typeof query === 'string';
      if (typeOfQuery) routeTypesInStore.push(query);
      else {
        query.map((t: string) => {
          routeTypesInStore.push(t);
        });
      }
      this.routeTypes = routeTypesInStore;
    }

    if (this.$route.query?.opened) {
      routeIsOpened = true;
      this.routeOpened = routeIsOpened;
    }

    if (this.$route.query['difficulties[]']) {
      const query: any = this.$route.query['difficulties[]'];
      const typeOfQuery = typeof query === 'string';
      if (typeOfQuery) routeDifficultiesInStore.push(Number(query));
      else {
        query.map((t: string) => {
          routeDifficultiesInStore.push(Number(t));
        });
      }
      this.routeDifficulties = routeDifficultiesInStore;
    }

    if (this.$route.query?.elevation_min) {
      routeElevationMinInStore = Number(this.$route.query.elevation_min);
      this.routeElevationMin = routeElevationMinInStore;
    }

    if (this.$route.query?.elevation_max) {
      routeElevationMaxInStore = Number(this.$route.query.elevation_max);
      this.routeElevationMax = routeElevationMaxInStore;
    }

    if (this.$route.query?.distance_min) {
      routeDistancesMinInStore = Number(this.$route.query.distance_min);
      this.routeDistanceMin = routeDistancesMinInStore;
    }
    if (this.$route.query?.distance_max) {
      routeDistancesMaxInStore = Number(this.$route.query.distance_max);
      this.routeDistanceMax = routeDistancesMaxInStore;
    }

    if (this.$route.query?.routeCity) {
      routeCity = this.$route.query.routeCity;
      this.cityFiltered = routeCity;
    }

    const eventTypes: string[] = [];
    let eventSince: any = '';
    let eventUntil: any = '';

    if (this.$route.query['event_type[]']) {
      const query: any = this.$route.query['event_type[]'];
      const typeOfQuery = typeof query === 'string';
      if (typeOfQuery) eventTypes.push(query);
      else {
        query.map((t: string) => {
          eventTypes.push(t);
        });
      }
      this.eventTypes = eventTypes;
    }

    if (this.$route.query['sport'] || this.$route.query['sport[]']) {
      const query: any = this.$route.query['sport'] || this.$route.query['sport[]'];
      const sports = typeof query === 'string' ? [Number(query)] : query.map((sportId: string) => Number(sportId));

      this.routeSports = sports;
      this.eventSports = sports;
      this.destinationSports = sports;
    }

    if (this.$route.query['label[]']) {
      const query: any = this.$route.query['label[]'];
      const labels = typeof query === 'string' ? [Number(query)] : query.map((labelId: string) => Number(labelId));

      this.routeLabels = labels;
      this.eventLabels = labels;
      this.destinationLabels = labels;
    }

    if (!this.$route.query.since && !this.$route.query.until) {
      const today: string = this.$dayjs().format('YYYY-MM-DD');
      this.eventSince = today;
      eventSince = today;
    }

    if (this.$route.query.since) {
      eventSince = this.$route.query.since;
      this.eventSince = eventSince;
    }
    if (this.$route.query.until) {
      eventUntil = this.$route.query.until;
      this.eventUntil = eventUntil;
    }

    // Updating filters in store for better handling on next user's actions
    this.$store.commit('explorer/SET_DESTINATION_MAP_DESTINATIONS_FILTERS', {
      landscape: destinationLandscapes,
      respect: destinationRespect,
      label: this.destinationLabels,
      sports : this.destinationSports,
    });

    // Updating filters in store for better handling on next user's actions
    this.$store.commit('explorer/SET_DESTINATION_MAP_ROUTES_FILTERS', {
      types: routeTypesInStore,
      opened: routeIsOpened,
      difficulties: routeDifficultiesInStore,
      elevation_min: routeElevationMinInStore,
      elevation_max: routeElevationMaxInStore,
      distance_min: routeDistancesMinInStore,
      distance_max: routeDistancesMaxInStore,
      label: this.routeLabels,
      sports: this.routeSports,
      routeCity,
    });

    // Updating filters in store for better handling on next user's actions
    this.$store.commit('explorer/SET_DESTINATION_MAP_EVENTS_FILTERS', {
      event_type: eventTypes,
      since: eventSince,
      until: eventUntil,
      label: this.eventLabels,
      sport: this.eventSports,
    });
  }

  /*
    When user adds/removes a filter in destination Tab, we update associated data of
    this page so it will be easier to prepare this.destinationsList
  */
  populateDestinationFilters (payload: any) {
    this.activePayload = {};
    this.destinationRespects = payload.respect;
    this.destinationLandscapes = payload.landscape;
    this.destinationLabels = payload.label;
    this.destinationSports = payload.sport;
  }

  /* Same logic than this.populateDestinationFilters but for routes filters */
  populateRouteFilters (payload: any) {
    this.activePayload = {};
    this.routeDifficulties = payload.difficulties;
    this.routeOpened = payload.opened;
    this.routeTypes = payload.types;
    this.routeLabels = payload.label;
    this.routeSports = payload.sport;
    this.routeElevationMin = payload.elevation_min;
    this.routeElevationMax = payload.elevation_max;
    this.routeDistanceMin = payload.distance_min;
    this.routeDistanceMax = payload.distance_max;
  }

  /* Same logic than this.populateDestinationFilters but for events filters */
  populateEventFilters (payload: any) {
    this.activePayload = {};
    this.eventTypes = payload.event_type;
    this.eventLabels = payload.label;
    this.eventSince = payload.since;
    this.eventUntil = payload.until;
    this.eventSports = payload.sport;
  }

  /*
    This method will update the list of destinations to display in both cards and map.
    Filters that were applied in dropdowns are handled.
  */
  async searchDestinations (payload: any) {
    await this.$store.dispatch('explorer/getDestinationsList', {
      lang: this.locale,
      landscape: this.destinationLandscapes,
      respect: this.destinationRespects,
      sport_ids: this.destinationSports,
      label_ids: this.destinationLabels,
      lat_min: this.mapBounds?.lat_min,
      lat_max: this.mapBounds?.lat_max,
      long_min: this.mapBounds?.long_min,
      long_max: this.mapBounds?.long_max,
      offset: this.destinationOffset,
      limit: 12,
      has_more: this.destinationsList.has_more,
      reset_append: payload.reset_append || this.forceReset,
    });

    // When payload.prevent_map_reload is true, it means that we don't want
    // the map to be rendered with new elements. The main case for this
    // behavior is when user scrolls inside cards div, reaches bottom so triggers
    // infinite scroll fetch. On the map, all the markers of every (or filtered)
    // destinations are displayed. It is redundant to fetch datas that are here
    // already, so we prevent it.
    if (!payload.prevent_map_reload) {
      await this.getDestinationsMap();
    }

    // this.forceReset is a data that can be updated by ExplorerMap when user
    // uses "Select in this area". We want this data to be back to false when
    // store values have been reset to [] so it will load datas from offset 0
    // in this specific case
    this.forceReset = false;

    // Update this.destinationDestinationFilters state
    this.$store.commit('explorer/SET_DESTINATION_MAP_DESTINATIONS_FILTERS', {
      landscape: this.destinationLandscapes,
      respect: this.destinationRespects,
      label: this.destinationLabels,
      sport: this.destinationSports,
    });
  }

  /*
    This method will update destinations markers displayed in map. It is called only
    when:

    - User triggers a new global search (aroundMe, specific zone, specific place)
    - User applies a filter inside of the dropdowns

    It won't be triggered if user fetches more routes when infinite-scrolling
    down the cards div.
   */
  async getDestinationsMap () {
    await this.$store.dispatch('explorer/getDestinationsMap', {
      lang: this.locale,
      landscape: this.destinationLandscapes,
      respect: this.destinationRespects,
      sport_ids: this.destinationSports,
      label_ids: this.destinationLabels,
      lat_min: this.mapBounds?.lat_min,
      lat_max: this.mapBounds?.lat_max,
      long_min: this.mapBounds?.long_min,
      long_max: this.mapBounds?.long_max,
    });
  }

  /* See this.searchDestinations for explanations as it follow the same logic */
  async searchRoutes (payload: any) {
    this.elevationRange = [this.routeElevationMin, this.routeElevationMax];
    this.distanceRange = [this.routeDistanceMin, this.routeDistanceMax];

    await this.$store.dispatch('explorer/getRoutesList', {
      types: this.routeTypes,
      difficulties: this.routeDifficulties,
      sport_ids: this.routeSports,
      label_ids: this.routeLabels,
      opened: this.routeOpened,
      lang: this.locale,
      lat_min: this.mapBounds?.lat_min,
      lat_max: this.mapBounds?.lat_max,
      long_min: this.mapBounds?.long_min,
      long_max: this.mapBounds?.long_max,
      elevation_min: this.elevationRange[0],
      elevation_max: this.elevationRange[1],
      distance_min: this.distanceRange[0],
      distance_max: this.distanceRange[1],
      offset: this.routeOffset,
      city: this.cityFiltered,
      limit: 12,
      has_more: this.routesList.has_more,
      reset_append: payload.reset_append || this.forceReset,
    });

    if (!payload.prevent_map_reload) {
      await this.getRoutesMap();
    }

    this.forceReset = false;

    this.$store.commit('explorer/SET_DESTINATION_MAP_ROUTES_FILTERS', {
      types: this.routeTypes,
      label: this.routeLabels,
      opened: this.routeOpened,
      difficulties: this.routeDifficulties,
      elevation_min: this.routeElevationMin,
      elevation_max: this.routeElevationMax,
      distance_min: this.routeDistanceMin,
      distance_max: this.routeDistanceMax,
      routeCity: this.cityFiltered,
      sport: this.routeSports,
    });
  }

  /* See this.getDestinationsMap for explanations as it follow the same logic */
  async getRoutesMap () {
    await this.$store.dispatch('explorer/getRoutesMap', {
      types: this.routeTypes,
      difficulties: this.routeDifficulties,
      sport_ids: this.routeSports,
      label_ids: this.routeLabels,
      opened: this.routeOpened,
      lang: this.locale,
      lat_min: this.mapBounds?.lat_min,
      lat_max: this.mapBounds?.lat_max,
      long_min: this.mapBounds?.long_min,
      long_max: this.mapBounds?.long_max,
      elevation_min: this.elevationRange[0],
      elevation_max: this.elevationRange[1],
      distance_min: this.distanceRange[0],
      distance_max: this.distanceRange[1],
    });
  }

  /* See this.getDestinations for explanations as it follow the same logic */
  async searchEvents (payload: any) {
    await this.$store.dispatch('explorer/getEventsList', {
      event_type: this.eventTypes,
      sport_ids: this.eventSports,
      label_ids: this.eventLabels,
      lang: this.locale,
      lat_min: this.mapBounds?.lat_min,
      lat_max: this.mapBounds?.lat_max,
      long_min: this.mapBounds?.long_min,
      long_max: this.mapBounds?.long_max,
      since: this.eventSince,
      until: this.eventUntil,
      offset: this.eventOffset,
      limit: 12,
      has_more: this.eventsList.has_more,
      reset_append: payload.reset_append || this.forceReset,
    });

    if (!payload.prevent_map_reload) {
      await this.getEventsMap();
    }

    this.forceReset = false;

    this.$store.commit('explorer/SET_DESTINATION_MAP_EVENTS_FILTERS', {
      sport: this.eventSports,
      event_type: this.eventTypes,
      label: this.eventLabels,
      since: this.eventSince,
      until: this.eventUntil,
    });
  }

  /* See this.getDestinationsMap for explanations as it follow the same logic */
  async getEventsMap () {
    await this.$store.dispatch('explorer/getEventsMap', {
      event_type: this.eventTypes,
      sport_ids: this.eventSports,
      label_ids: this.eventLabels,
      lang: this.locale,
      lat_min: this.mapBounds?.lat_min,
      lat_max: this.mapBounds?.lat_max,
      long_min: this.mapBounds?.long_min,
      long_max: this.mapBounds?.long_max,
      since: this.eventSince,
      until: this.eventUntil,
    });
  }
}
